export const AddressType = {
	Billing: 'Billing',
	Shipping: 'Shipping',
};
